import React, {useState} from 'react';
import styled from 'styled-components';

import Row from "./../../../common/components/Row.js";
import Col from "./../../../common/components/Col.js";
import Card from "./../../../common/components/Card.js";
import Button from "./../../../common/components/Button.js";
import Typo from "./../../../common/components/Typo.js";
import Input from "./../../../common/components/Input.js";

const Error = styled.div.withConfig({displayName:'-Error'})`
  height: 30px;
  color: red;
`;
const Cta = styled.span`
  cursor: pointer;
`;

const FormLogin = ({enableRegistration, onConfirm, error}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (

    <Card>
      <Typo variant="h1">Sign in</Typo><br/>
      <>Enter your credentials to log in.</>

      <Row>
        <Col widthmd="12">
          <Input
            label={"Email"}
            name="email"
            type="email"
            width="100%"
            value={email}
            onChange={(val) => setEmail(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Input
            label={"Password"}
            name="password"
            type="password"
            width="100%"
            value={password}
            onChange={(val) => setPassword(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Button onClick={() => onConfirm({
            action: "login",
            params: {
              email: email,
              password: password
            }
          })}>Sign in</Button>

        </Col>
        <Col widthmd="12">
          <Error>
            <br/>{error}<br/>
          </Error>
        </Col>
        <Col widthmd="12">
          {enableRegistration ?
            <>
              Don't have an account yet? <Cta onClick={() => onConfirm({
                action: "navigate",
                params: {
                  page: "registration"
                }
              })}>Sign up</Cta>.<br/>
            </>
          : null }
          Have you forgotten your password? <Cta onClick={() => onConfirm({
            action: "navigate",
            params: {
              page: "forgot-password"
            }
          })}>Recover it</Cta>.
        </Col>
      </Row>
    </Card>
  )
}

export default FormLogin;
